import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M19.586 4a2 2 0 0 1 2.828 0L28 9.586a2 2 0 0 1 0 2.828l-15 15c-.188.188-.41.334-.65.434l-.117.044a2 2 0 0 1-.647.108H6a2 2 0 0 1-2-2v-5.586a2 2 0 0 1 .103-.633l.052-.137c.099-.239.245-.458.43-.644zM5.999 22.413 6 26h3.585zM17 9.414 6.414 20l5.585 5.586L22.585 15zm4-4L18.414 8 24 13.585 26.586 11z"
    />
  </svg>
);
const SvgIconPencilSimple = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconPencilSimple);
export default Memo;
